// Personnel cost comparison (views/controlling/StaffCostComparison.vue). Status codes from the backend stay as they are.
export default {
  en: {
    staffCost: {
      filters: 'Filters',
      hubstaffRateHint: 'No rate in IQ – cost uses the Hubstaff pay rate',
      intro: 'TimeMoto + Hubstaff calculation (nightly job) against the Google Sheet "Übersicht Personalkosten", per employee and month.',
      dateRange: 'Date range (whole months)',
      status: 'Status',
      all: 'All',
      load: 'Load',
      totalsTitle: 'Monthly totals',
      totalsHint: '"ok" = difference ≤ € {abs} or ≤ {pct} %. Goal for the switch: two to three months without deviation.',
      rowsTitle: 'Per employee and month',
      onlySheetHint: '(no clockings and no fixed salary in IQ)',
      onlyComputedHint: '(person/month missing in the sheet)',
      forbiddenTitle: 'No access',
      forbidden: 'Visible to the Admin role only.',
      loadFailedTitle: 'Error',
      loadFailed: 'Comparison could not be loaded.',
      sheetName: 'Comparison',
      totalCols: {
        month: 'Month',
        computed: 'IQ (TimeMoto + Hubstaff)',
        sheet: 'Sheet (Angela)',
        diff: 'Difference',
        rows: 'Rows',
        deviations: 'of which not ok',
      },
      cols: {
        month: 'Month',
        team: 'Team',
        employee: 'Employee',
        hours: 'Hours (TimeMoto + Hubstaff)',
        rate: 'Rate',
        salary: 'Fixed salary',
        factor: 'Employer factor',
        computed: 'IQ calculated',
        sheet: 'Sheet',
        diff: 'Difference',
        status: 'Status',
      },
      xlsx: {
        hours: 'Hours TimeMoto + Hubstaff',
        diffPct: 'Difference %',
      },
    },
  },
  de: {
    staffCost: {
      filters: 'Filter',
      hubstaffRateHint: 'Kein Satz in IQ – Kosten mit dem Hubstaff-Stundensatz',
      intro: 'TimeMoto- + Hubstaff-Berechnung (Nachtjob) gegen das Google Sheet „Übersicht Personalkosten“, je Mitarbeiter und Monat.',
      dateRange: 'Zeitraum (ganze Monate)',
      status: 'Status',
      all: 'Alle',
      load: 'Laden',
      totalsTitle: 'Monatssummen',
      totalsHint: '„OK“ = Abweichung ≤ € {abs} oder ≤ {pct} %. Ziel für die Umstellung: zwei bis drei Monate ohne Abweichung.',
      rowsTitle: 'Je Mitarbeiter und Monat',
      onlySheetHint: '(keine Stempelungen und kein Fixgehalt in IQ)',
      onlyComputedHint: '(im Sheet fehlt die Person/der Monat)',
      forbiddenTitle: 'Kein Zugriff',
      forbidden: 'Nur für Admin-Rolle sichtbar.',
      loadFailedTitle: 'Fehler',
      loadFailed: 'Abgleich konnte nicht geladen werden.',
      sheetName: 'Abgleich',
      totalCols: {
        month: 'Monat',
        computed: 'IQ (TimeMoto + Hubstaff)',
        sheet: 'Sheet (Angela)',
        diff: 'Differenz',
        rows: 'Zeilen',
        deviations: 'davon nicht ok',
      },
      cols: {
        month: 'Monat',
        team: 'Team',
        employee: 'Mitarbeiter',
        hours: 'Std. (TimeMoto + Hubstaff)',
        rate: 'Satz',
        salary: 'Fixgehalt',
        factor: 'AG-Faktor',
        computed: 'IQ berechnet',
        sheet: 'Sheet',
        diff: 'Differenz',
        status: 'Status',
      },
      xlsx: {
        hours: 'Std. TimeMoto + Hubstaff',
        diffPct: 'Differenz %',
      },
    },
  },
}
